module.exports = __webpack_public_path__ + "static/media/flag-de.b3a26713.svg";